export default __webpack_public_path__ + "static/media/package1.c93ae2d1.png";